show_relef_catalog = ( ) ->
    new Promise( ( resolve, reject ) =>
        url = "brands/relef/catalog.php"
        data = {}
        $.post( url, data ).done( ( response, status, xhr ) =>
            $( '#contenttable' ).html( response )
        ).fail( ( xhr, status, error ) =>
            reject( error )
        )
    )